import { AxiosResponse } from 'axios'
import api from '../../libs/api'
import { DispatcherResponse } from '../../typings/ReduxDispatch'
import { actions } from './reducer'

class Dispatcher {
  checkPhone(phone_number: string): DispatcherResponse<{ code?: string; verification_id: string } | undefined> {
    return async (dispatch) => {
      const response: AxiosResponse<{ code?: string; verification_id: string }> =
        (await api.onboardCheckPhoneNumberCreate({ phone_number })) as any

      const { data, status } = response || {}
      console.log('checkPhoneAction', data, response)

      dispatch(
        actions.setVerification({
          verification_code: data?.code,
          verification_id: data?.verification_id,
        }),
      )

      return data
    }
  }
}

const PhoneDispatcher = new Dispatcher()
export default PhoneDispatcher
